import { render } from "./Anketa.vue?vue&type=template&id=432bdd60&scoped=true"
import script from "./Anketa.vue?vue&type=script&lang=js"
export * from "./Anketa.vue?vue&type=script&lang=js"

import "./Anketa.vue?vue&type=style&index=0&id=432bdd60&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432bdd60"]])

export default __exports__